import { Pessoa } from '@tivic-team/manager-ts/dist/grl';

export class MedicoDTO extends Pessoa {

    cdPessoa: number;
    nmPessoa: string;
    cdVinculo: number;
    cdEmpresa: number;

    constructor(cdPessoa?: number, nmPessoa?: string, cdVinculo?:number, cdEmpresa?: number) {
        super()
        this.cdPessoa = cdPessoa;
        this.nmPessoa = nmPessoa;
        this.cdVinculo = cdVinculo;
        this.cdEmpresa = cdEmpresa;
        
    }
}